<script lang="ts" >
  import { Button, Col } from 'sveltestrap';
  import { toasts, ToastContainer, FlatToast } from 'svelte-toasts';
  import Card from '../../Core/Card.svelte';
  import { AutoClosein1000Sec, AutoClosein15000Sec, AutoClosein5000Sec, AutoClosein500Sec, CustomAutoPlayExample } from '../../../utils/Constant/Constant';
  const basictoaster = (toastname) => {
    switch (toastname) {
      case 'customAutoplay15':
        toasts.add({
          theme: 'light',
          description: 'Success Notification !',
          placement: 'top-center',
          type: 'success',
          showProgress: true,
          duration: 15000,
        });
        break;
      case 'customAutoplay5':
        toasts.add({
          description: 'Info Notification !',
          placement: 'bottom-center',
          type: 'info',
          duration: 5000,
        });
        break;
      case 'customAutoplay1':
        toasts.add({
          description: 'Warning Notification !',
          placement: 'bottom-left',
          type: 'warning',
          duration: 1000,
        });
        break;
      case 'customAutoplay0.5':
        toasts.add({
          description: 'Danger Notification !',
          placement: 'bottom-right',
          type: 'error',
          duration: 500,
        });
        break;
      default:
        break;
    }
  };
</script>
<ToastContainer {toasts} let:data>
    <FlatToast {data} />
    <!-- default slot as toast component -->
</ToastContainer>
<Col sm="12">
  <Card headerTitle={CustomAutoPlayExample} cardBodyprops="btn-showcase">
    <div slot="contentbody">
      <Button name="customAutoplay15" color="success" on:click={(e) => basictoaster(e.target.name)}>{AutoClosein15000Sec}</Button>
      <Button name="customAutoplay5" color="info" on:click={(e) => basictoaster(e.target.name)}>{AutoClosein5000Sec}</Button>
      <Button name="customAutoplay1" color="warning" on:click={(e) => basictoaster(e.target.name)}>{AutoClosein1000Sec}</Button>
      <Button name="customAutoplay0.5" color="danger" on:click={(e) => basictoaster(e.target.name)}>{AutoClosein500Sec}</Button>
    </div>
  </Card>
</Col>